<template>
    <div>
        <!-- <subNavbar :list="nav.hexinyewu" @click="subNavbarItemClick"/> -->
        <div>
            <img src="../assets/banner/核心业务banner1920x280px.png">
        </div>
        <div class="container margin-auto margin-top-30" style="text-align: justify;line-height: 1.7;">
            <orderMenu :isHtml="false"  :list="nav.hexinyewu" @change="orderMenuChange" ref="orderMenu">
                 <doors v-if="is_doors" :list="list" ref="doors" @jump="jump" />
                 <hardback v-if="is_hardback" :list="list" ref="hardback"  @jump="jump"  />
                 <curtain v-if="is_curtain" :list="list" ref="curtain"  @jump="jump"  />
            </orderMenu>
        </div>
    </div>
</template>

<script>
    import {getBusiness} from '../api/api'
    import subNavbar from '../components/subNavbar'
    import orderMenu from '../components/orderMenu'
    import doors from '../components/doors'
    import {mapGetters,mapMutations} from 'vuex'
    import hardback from '../components/hardback'
    import curtain from '../components/curtain'
    export default {
        name: 'CoreBusiness',
        components:{
            subNavbar,
            orderMenu,
            doors,
            hardback,
            curtain
        },
        computed:{
            ...mapGetters({
                nav:'getNav'
            })
        },
        watch:{
            // nav(newsVal){
    
            //     if(this.nav.hexinyewu.length>0){
            //         this.getBusiness(this.nav.hexinyewu[0].id,1)
            //     }
            // },
            '$route':'getIndex'
        },
        data() {
            return {
                list:[
                    {},
                    {},
                    {},
                    {},
                    {}
                ],
                index:0,
                is_doors:true,
                is_curtain:false,
                is_hardback:false,
                type:1
                // list:[
                //     {title:'门窗系列',html:'门窗系列'},
                //     {title:'幕墙系列',html:'幕墙系列'},
                //     {title:'精装系列',html:'精装系列'},
                //     {title:'综合业务',html:'综合业务'},
                // ]
            }
        },
        methods:{
            getBusiness(id){
                 this.type=id;
            
                 localStorage.setItem('corId',id);
             
                getBusiness({typeid: localStorage.getItem('corId')}).then(res=>{
                    if(res.code==1){
  
                         this.list=res.data
                      
                         if(this.index==3){
                            this.$router.push({path: '/CoreBusinessDetail',   query: {id:this.list[0]['id'],index:this.index,xiang:0}})
       
                            return;
                        }

                    }
                })
            },
            subNavbarItemClick(index){
              
                this.list=[
                    {},
                    {},
                    {},
                    {},
                    {}
                ];
                if(index==undefined){
                    index=0;
                }
                this.statusIS(parseInt(index));
            
                this.index=index
                this.$refs.orderMenu.setActive(index);
             
              



            let id='';
                if(this.nav.hexinyewu[index]!=undefined){
          
                    id=this.nav.hexinyewu[index].id;
                }else{
                    id=localStorage.getItem('corId');
                }
           


                this.getBusiness(id)
            },
            getIndex(){
        
                
                this.subNavbarItemClick(this.$route.query.index)
            },
            orderMenuChange(index){

                   // console.log(index);
                
                this.$router.push({path: '/CoreBusiness', query: {index: index}})
       
          
            },
            statusIS(index){
                switch(index){
                    //门窗
                    case 0:
  
                         this.is_hardback=false;
                         this.is_curtain=false;
                         this.is_doors=true;
                        break;
                    //幕墙    
                    case 1:
              
                         this.is_doors=false;
                         this.is_hardback=false;
                         this.is_curtain=true;
                     
                        break;  
                    //精装修
                    case 2:
          
                         this.is_doors=false;
                         this.is_curtain=false;
                         this.is_hardback=true;
                        break;    
                    case 3:

                        break;    
    
                    default:
              
                         this.is_doors=false;
                         this.is_hardback=false;
                         this.is_curtain=false;
                        break;    
                }
            },
            jump(id){
        
                // this.$router.push({path:'/CoreBusinessDetail',query:{id:id}})

                let routeData = this.$router.resolve({
                    path: "/CoreBusinessDetail",
                        query: {id:id,index:this.index,pid:this.type}
                });
                window.open(routeData.href, '_blank');
            }
            
        },
        mounted(){
      


                       
           // if(this.$route.query.index){
 
                // console.log(this.$route.query.id)
                this.subNavbarItemClick(this.$route.query.index)
          //  }
            // if(this.nav.hexinyewu.length>0){
             
            //     console.log(445);
            //     this.getBusiness(this.nav.hexinyewu[this.$route.query.index?this.$route.query.index:0].id,1)
            // }

            // console.log(this.$route.query.index)
        }
    }
</script>

